import AllExam from './AllExam.gql';

export default AllExam;
